import React from 'react'
import injectSheet from 'react-jss'
import styles from './slide-constructor.styles'
import SlideControls from '../slide-controls/slide-controls.container'
import MobileSidebar from './mobile-sidebar/mobile-sidebar.container'
import classNames from 'classnames'
import { Presentation } from 'pobble-components/dist/presentation'
import withPresentation from '../with-presentation'

const SlideConstructor = ({ classes, id, presentation, presentationState }) => {
  const activeSlide = presentationState.slides[presentationState.activeSlideId]
  const note = activeSlide.public_note
  const activeSlideId = activeSlide.id
  return (
    <div
      className={classNames(classes.container, {
        [classes.infoOpened]: presentationState.infoOpened
      })}>
      <Presentation
        readOnly
        slideProps={{ containerClassName: classes.slide }}
        data={presentation}
        activeSlideId={activeSlideId}
      />
      <div className={classes.footer}>
        {note && (
          <p className={classes.note}>
            <strong>Teaching notes: </strong>
            {note}
          </p>
        )}
        <SlideControls className={classes.controls} />
      </div>
      <MobileSidebar />
    </div>
  )
}

export default withPresentation(injectSheet(styles)(SlideConstructor))
